// extracted by mini-css-extract-plugin
export default {"wrapper":"Sr-z","response":"Tr-z","error":"Ur-z","disabled":"Vr-z","buttons":"Wr-z","feedbackQuestionSection":"Xr-z","yesNoWrapper":"Yr-z"};